export default __webpack_public_path__ + "static/media/Mark-4-HUD-Pop-Up (1 Layer).2243dc07.jpg";